import messages from './cmsContentLocale.json' with { type: 'json' };

export const cmsContentLocaleEn: Readonly<typeof messages> = messages;
